import React from "react";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { usePrivacyPolicy } from "../hooks/privacy-policy";
import LoadingErrorState from "../components/ui/LoadingErrorState";

type Language = {
  languageCode: string;
  content: string; // HTML from API
};

export type Policy = {
  id: number;
  type: string;
  languages: Language[];
};

function PrivacyPolicyPage() {
  const {t} = useTranslation();
  const {data,isError,isLoading} = usePrivacyPolicy();

  return (
    <div className="min-h-screen bg-light text-Black flex flex-col">
      {/* Header */}
      <header className="bg-primary py-10 shadow-custom-light">
        <div className="container px-4">
          <h1 className="text-3xl md:text-4xl font-bold text-white text-center">
            {t('privacy_policy')}
          </h1>
        </div>
      </header>

      {/* Main Content */}
      <main className="container px-4 py-12 max-w-4xl mx-auto flex-1">
        <LoadingErrorState
        isError={isError}
        isLoading={isLoading}
        />

          <div
            dir={i18next.language==="ar"?"rtl":"ltr"}
            className="prose prose-lg max-w-none text-muted leading-relaxed"
            // ✅ render HTML from API
            dangerouslySetInnerHTML={{ __html: data?.languages[0].content||"" }}
          />
      </main>

      {/* Footer */}
      <footer className="bg-dark text-light py-6 text-center text-sm">
        © {new Date().getFullYear()} La-Hent.
      </footer>
    </div>
  );
}

export default PrivacyPolicyPage;
